import { Button } from "@noones/ui";
import { tw } from "@noones/ui/tw";
import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

export const ContactSupport = () => {
    return (
        <div className={tw.flex.flex_col.gap_2.px_4.mt_6}>
            <div className={tw.text_h3.font_semibold}>
                <FormattedMessage {...messages.title} />
            </div>

            <div className={tw.text_body_14.font_normal.text_grey_green}>
                <FormattedMessage {...messages.description} />
            </div>

            <Button
                mode="green"
                size={48}
                className={tw.w_full}
                href="https://help.noones.com/portal/newticket"
                component="a"
            >
                <FormattedMessage {...messages.contactUs} />
            </Button>
        </div>
    );
};

const messages = defineMessages({
    title: {
        id: "ContactSupport.title",
        defaultMessage: "Contact support",
        description: "title",
    },
    description: {
        id: "ContactSupport.tradesDaily",
        defaultMessage:
            "If you're experiencing issues with any of our services or have suggestions, let us know!",
        description: "description",
    },
    contactUs: {
        id: "ContactSupport.transactionsDaily",
        defaultMessage: "Contact Us",
        description: "Contact Us",
    },
});
